export default {
    // flag: icons.united_states,
    language: 'English',
    success: 'Success',
    account: 'Account',
    phoneNumber: 'Phone Number',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    dashboard: 'Dashboard',
    welcome: 'Welcome',
    category: 'Category',
    subCategory: 'Sub Cat',
    notes: 'Notes',
    entryAllowed: 'Entry Allowed',
    complete: 'Complete',
    notifyTenant: 'Notify Resident',
    open: 'Open',
    accept: 'Accept',
    decline: 'Withdraw',
    noPending: 'There are no work orders assigned to you. \nPlease contact your manager to assign work orders.',
    order: 'Order',
    details: 'Details',
    materials: 'Materials',
    pause: 'Pause',
    presshold: 'Press and Hold To Logout.',
    clickscan: 'Click to Scan',
    withdrawreason: 'Reason For Withdrawal',
    completenotes: 'Work Order Completion Notes',
    youhave: 'You Have',
    assignments: 'Assignments',
    signout: 'Sign Out',
    completethisorder: 'Complete this Order',
    mysettings: 'My Settings',
    createNote: 'Create Note',
    noteText: 'Enter your note',
    snapPhoto: 'Take Photo',
    cancelPhoto: 'Cancel Photo',
    languageChanged: 'Language Changed',
    noteSaved: "Note Saved",
    myToolbox: "My ToolBox",
    addSuccess: "your items have been succesfully added to your toolbox. Please note that if you're inclined to return anything you must bring it back to this shop.",
    confirmItems: 'Please confirm these are the only items you are taking from the shop',
    thankYou: 'Thank You!',
    cancel: 'Cancel',
    confirm: 'Confirm',
    confirmCheckOut: "Confirm Checkout",
    processedCheckOut: "Congratulations, checkout processed!",
    shopItems: 'Shop Items',
    signedOut: 'you will be signed out in',
    youHave: 'You have',
    itemsIn: 'items in your',
    cart: 'cart',
    toolbox: 'toolbox',
    checkOut: 'Checkout',
    return: 'Return',
    available: 'Available',
    name: 'Name',
    //RENTALAPPLICATION FORM below
    occupants: 'Occupants',
    status: 'Status',
    full_name: 'Full Name',
    email: 'Email',
    dob: 'Date of Birth',
    ssn: 'Social Security Number',
    home_phone: 'Home Phone',
    work_phone: 'Work Phone',
    cell_phone: 'Cell Phone',
    number: 'Number',
    state: 'State',
    //Move in Info
    mii: 'Move In Information',
    emi: 'Expected Move In',
    unit_number: 'Unit Number',
    //Pets
    add_pet: 'Add Pet',
    pet: 'Pet',
    type: 'Type',
    breed: 'Breed',
    weight: 'Weight',
    //Vehicles
    vehicle: 'Vehicle',
    model: 'Make/Model',
    color: 'Color',
    license: 'License Plate',
    add_vehicle: 'Add Vehicle',
    //Previous Residences
    prev_residences: 'Current Residency',
    address: 'Address',
    duration_residency: 'Duration of Residency',
    landlord_name: 'Landlord  Name',
    landlord_num: 'Landlord Number',
    landlord_email: 'Landlord Email',
    //Employment Info
    employment_info: 'Employment Information',
    employer: 'Employer',
    occupant: 'Occupant',
    supervisor_name: 'Supervisor Name',
    employment_duration: 'Duration of Employment',
    salary: 'Monthly Salary',
    other_income: 'Other Income',
    description: 'Description',
    monthly_income: 'Monthly Income',
    //Emergency Contacts
    add_contact: 'Add Contact',
    contact: 'Contact',
    relationship: 'Relationship',
    //Documents
    add_document: 'Add Document',
    required_document: "Your pay-stub(s) and driver's license or other form of state-issued ID are required as part of the application process.",
    document: 'Document',
    file: 'File',
    pay_stub: 'Pay Stub',
    choose_file: 'Choose File',
    pets_vehicles: 'Pets and Vehicles',
    continue_saved: 'Continue Saved Application',
    prev: 'Previous',
    save: 'Save',
    next: 'Next',
    //labels
    move_in: 'Move In Information',
    pets: 'Pets',
    vehicles: 'Vehicles',
    histories: 'Current Residency',
    employments: 'Employment Information',
    income: 'Income',
    emergency_contacts: 'Emergency Contacts',
    documents: 'Upload Documents',
    review: 'Review',
    //ERRORS
    common_errors: {
        name: 'Please enter the name',
        phone: 'Please enter the 10 digit phone number',
        empty_email: 'Please enter the email',
        valid_email:'Please enter a valid email address',
    },
    landing_page_errors: {
        email_error: "Enter a valid email to proceed!"
    },
    occupant_errors: {
        leaseholder_dob: 'Lease Holder must be over',
        future_date: 'Future date cannot be selected',
        no_date: 'Please select date of birth',
        ssn: 'Please enter a 9 digit social security number',
        phone: 'Please enter at least one valid number',
    },
    movein_errors: {
        movein_date: 'Please select future date',
        floor_plan: 'Please select a floor plan',
        unit_number: 'Please select a unit',
        allowed_date: 'Only future or already selected date is allowed'
    },
    vehicle_errors: {
        model: 'Please enter a model',
        color: 'Please enter a color',
        license: 'Please enter a license number',
        state: 'Please enter a state'
    },
    pet_errors: {
        name: 'Please enter a name',
        breed: 'Please enter a breed',
        weight: 'Please enter a weight',
        type: 'Please enter a type'
    },
    residency_errors: {
        address: 'Please enter the address',
        state:'Please enter the state name',
        city:'Please enter the city',
        zip:'Please enter the zip',
    },
    contacts_errors: {
        relationship: 'Relationship field is required'
    },
    employment_errors: {
        employment_duration: 'Please enter the duration of employment',
        supervisor_name: 'Please enter the supervisor name',
        monthly_income: 'Please enter your monthly income',
        extra_income: 'Please enter your extra monthly income',
        extra_income_description: 'Please enter the descripton for extra monthly income',
    },
    document_errors: {
        license: 'Please upload the driver\'s License',
        pay_stub: 'Please upload the payStub'
    },

    description_error: 'Enter Description',
    //person.js
    name_error: 'Enter Name',
    ssn_error: 'Invalid SSN (enter 9 digits only)',
    email_error: 'Enter valid email',
    phone_error: 'Enter at least one phone number',
    invalid_dob: 'Date of birth is invalid',
    too_young: `Lease Holder must be over ${window.MINIMUM_AGE || 18}`,
    license_error: 'Enter drivers license number',
    license_state_error: 'Select drivers license state',
    status_error: 'Select Occupant Status',
    //movein.js
    movein_error: 'Enter move in date',
    //address.js
    invalid_address: 'Invalid Address',
    address_error: 'Enter address',
    city_error: 'Enter city',
    state_error: 'Enter state',
    zip_error: 'Enter Zip Code',
    //histories.js
    ll_name_error: 'Enter Landlord Name',
    ll_num_error: 'Enter Landlord Phone Number',
    rent_error: 'Enter rent amount',
    residency_duration_error: 'Enter duration of residency',
    current_error: 'Enter Current',
    landlord_email_error: 'Enter valid Landlord Email',
    //employment.js
    choose_occupant: 'Choose Occupant',
    employment_duration_error: 'Enter employment duration',
    employment_name_error: 'Enter employer name',
    employment_num_error: 'Enter employer phone number',
    employment_email_error: 'Enter supervisor email',
    employment_super_error: 'Enter supervisor name',
    employer_email_error: 'Enter valid employer email',
    salary_error: 'Enter salary',
    //pet.js
    pet_name_error: 'Enter pet name',
    pet_breed_error: 'Enter pet breed',
    pet_type_error: 'Enter pet type',
    pet_weight_error: 'Enter pet weight',
    //vehicle.js
    vehicle_mm_error: 'Enter vehicle make/model',
    vehicle_color_error: 'Enter vehicle color',
    vehicle_license_error: 'Enter license plate number',
    vehicle_license_state_error: 'Enter license plate state',
    //contact.js
    contact_name_error: 'Enter contact name',
    contact_phone_error: 'Enter contact phone',
    contact_phone_same_as_occupant: 'Enter a phone number that is unique from the applicants',
    contact_relation_error: 'Enter contact relationship',
    //doocument.js
    document_type_error: 'Enter document type',
    //Review & Pay & Terms
    submit_app_button: 'Submit My Application',
    submit_fix_errors_button: 'Please correct errors',
    accept_t_and_c_header: 'Please Accept the Terms and Conditions',
    name_and_agree_input: 'agree to the terms and conditions listed above',
    fee_refundability: "Fees paid are non-refundable.",
    fee_information: "Complete applications (those submitted with payment of both the Application Fee and Administrative Fee) will be processed by our staff immediately upon receipt, resulting in the soonest possible move-in date for accepted applicants. All other applications will be processed in the order received, which may result in delays if information or documentation is missing.",
    pay_admin_fee_now: "Pay Admin Fee now?",
    i: 'I',
    yes: 'Yes',
};